import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { API } from "../config/api-config";
import { HttpService } from "../service/http-service";
import { DragulaService } from "ng2-dragula/ng2-dragula";
import * as _ from "lodash";

declare var alertify: any;
@Component({
  selector: "app-latest-activity-list",
  templateUrl: "./latest-activity-list.component.html",
  styleUrls: ["./latest-activity-list.component.css"],
})
export class LatestActivityListComponent implements OnInit {
  constructor(
    private httpService: HttpService,
    private router: Router,
    private route: ActivatedRoute,
    private dragulaService: DragulaService
  ) {
    dragulaService.dropModel.subscribe((value) => {
      // console.log("drop: ${value[0]}");
      this.onDrop(value.slice(1));
    });
    dragulaService.setOptions("evented-bag", {
      copy: false,
    });
  }

  public pageData: any = {};
  public page = { pageNumber: 1 };
  public imagePath: string;
  public courseList = [];
  public searchValue: any = {
    search: "",
    active: "",
  };

  ngOnInit() {
    this.getPath();
    this.getData();
  }

  public data: Array<any> = [];

  getData(isSearch = false) {
    let data = { ...this.page };
    data.pageNumber--;
    if (isSearch) {
      let searchdata = {};
      for (let k in this.searchValue) {
        if (this.searchValue[k]) {
          searchdata[k] = this.searchValue[k];
        }
      }
      data = { ...data, ...searchdata };
    }
    this.httpService.getData(API.latestActivityList, data).then((response) => {
      this.pageData = response.data;
      this.data = response.data.content;
    });
  }

  private getPath(): void {
    this.httpService.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;
      this.getData();
    });
  }

  public pageChange(e: any) {
    this.page = e;
    this.getData();
  }
  public editActivity(id) {
    this.router.navigate(["/index/latestactivity/", id]);
  }

  public deleteActivity(id) {
    let _self = this;
    alertify.confirm(
      "删除",
      "確定要刪除嗎？",
      function () {
        _self.httpService
          .deleteData(API.latestActivity + "/" + id)
          .then((res) => {
            if (res.status.code == 0) {
              alertify.success(res.status.message);
              _self.getData();
            } else {
              alertify.error(res.status.message);
            }
          });
      },
      function () {}
    );
  }

  public searchData() {
    this.page.pageNumber = 1;
    this.getData(true);
  }

  private onDrop(args) {
    let [e, el] = args;
    // do something
    this.getList();
  }

  private postData = [];

  private getList() {
    this.postData = [];
    let sortData = _.cloneDeep(this.pageData.content);
    sortData.forEach((data, i) => {
      this.postData.push({
        id: data.id,
        rank: i + (this.page.pageNumber - 1) * this.pageData.size,
      });
    });
  }

  public updateSort() {
    this.httpService.postData(API.activitySort, this.postData).then((res) => {
      let data = res;
      if (data.status.code == 0 || data.status.code == "0") {
        alertify.success(data.status.message);
      } else {
        alertify.error(data.status.message);
      }
    });
  }

  private ngOnDestroy() {
    this.dragulaService.destroy("evented-bag");
  }

  public sortDown(item) {
    if (item.ranks < 0) {
      return;
    }
    let postData = [{ id: item.id, rank: item.ranks + 1 }];
    this.httpService.postData(API.activitySort, postData).then((res) => {
      let data = res;
      if (data.status.code == 0 || data.status.code == "0") {
        this.getData(true);
      } else {
        alertify.error(data.status.message);
      }
    });
  }
  public sortUp(item) {
    if (item.ranks <= 0) {
      return;
    }
    let postData = [{ id: item.id, rank: item.ranks - 1 }];
    this.httpService.postData(API.activitySort, postData).then((res) => {
      let data = res;
      if (data.status.code == 0 || data.status.code == "0") {
        this.getData(true);
      } else {
        alertify.error(data.status.message);
      }
    });
  }

  public inputSort(item) {
    alertify.prompt(
      "Sort",
      "Input sort number",
      item.ranks,
      (e, val) => {
        let postData = [{ id: item.id, rank: val }];
        this.httpService.postData(API.activitySort, postData).then((res) => {
          let data = res;
          if (data.status.code == 0 || data.status.code == "0") {
            this.getData();
          } else {
            alertify.error(data.status.message);
          }
        });
      },
      () => {}
    );
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/latest-activity-list/latest-activity-list.component.ts